import { space } from '../../components/styles';

export const desktopMinWidthPx = 800;
export const desktopMedia = `(min-width: ${desktopMinWidthPx}px)`;
export const padding = space(3);
